/* ---------------------------------------------------------------------------------------------------------------------
ADD ONS JS
--------------------------------------------------------------------------------------------------------------------- */
jQuery(document).ready(function ($) {

    $(document).on("show_variation found_variation", function (event, variation) {
        var $this = $(this);
        var $addOnVariations = $this.find('.add-on-variation_wrapper');
        if ($addOnVariations.length === 0) {
            return;
        }

        var variationPaymentPlan = variation.attributes['attribute_pa_payment-plan'];

        $addOnVariations.each(function () {
            var $addOnVariation = $(this),
                variationData = $addOnVariation.data('product-variations');

            var $radioGroup = $addOnVariation.find('.radio-group');
            var $radioDummyField = $radioGroup.find('.dummy-field')

            if ($radioGroup.length > 0) {
                if ($radioGroup.find('input[type=radio]').length >= 1) {
                    $radioGroup.find('.form-group:not(.dummy-field)').remove();
                }
            }

            var $checkbox = $addOnVariation.find('input[type=checkbox]');
            var $checkboxLabel = $addOnVariation.find('label[for="' + $checkbox.attr('id') + '"]');

            if ($checkbox.length > 0) {
                var $priceSpan = $checkboxLabel.find('span.price');
                $priceSpan.remove();
            }

            $.each(variationData, function (key, addOn) {
                var addOnAttributes = addOn.attributes;

                if (addOnAttributes['attribute_pa_payment-plan'] && addOnAttributes['attribute_pa_payment-plan'] === variationPaymentPlan) {
                    if ($radioGroup.length > 0) {

                        var wcssCustomMeta = addOn['wcss_custom_variation_meta'],
                            wcssCustomLabel = wcssCustomMeta && wcssCustomMeta['label'],
                            isDefault = wcssCustomMeta && wcssCustomMeta['default'],
                            $radioField = $radioDummyField.clone(),
                            $radioInput = $radioField.find('input[type=radio]'),
                            $radioLabel = $radioField.find('label');

                        $radioInput.attr('id', 'add_on_' + addOn.variation_id)
                            .attr('value', addOn.variation_id)
                            .attr('data-wcss-meta', JSON.stringify(wcssCustomMeta))
                            .prop('checked', isDefault);

                        $radioLabel.attr('for', 'add_on_' + addOn.variation_id).html(wcssCustomLabel + addOn.price_html);
                        $radioField.removeClass('dummy-field').show();
                        $radioGroup.append($radioField);
                    } else if ($checkbox.length > 0) {
                        $checkboxLabel.append(addOn.price_html);
                        $checkbox.val(addOn.variation_id);
                        return false;
                    }
                }
            });
        });

        $(document).trigger('add_ons_loaded', $this);
    });
});
